import { render, staticRenderFns } from "./JobsList.vue?vue&type=template&id=5cfb38d7&scoped=true&"
import script from "./JobsList.vue?vue&type=script&lang=js&"
export * from "./JobsList.vue?vue&type=script&lang=js&"
import style0 from "./JobsList.vue?vue&type=style&index=0&id=5cfb38d7&lang=scss&scoped=true&"
import style1 from "./JobsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfb38d7",
  null
  
)

export default component.exports